import { AJAX_TIMEOUT_MESSAGE } from '../helpers.js';
import { cleanupBootstrapModalBody } from '../shared/bootstrap-modal-cleanup.js';
import { checkoutIntentFor, clearCheckoutIntent } from '../shared/checkout-intent.js';
import { chargeWentThrough } from '../shared/charge-went-through.js';
import { applyChargeSuccess } from '../shared/apply-charge-success.js';
import { getMemberOverlayElement, showOverlay, hideOverlay } from '../shared/overlay.js';
import { isAllowedPinKey } from '../shared/field-validation.js';
import { openIndexPage } from './member-open-index-page.js';
import { showAlertMsg } from './member-show-alert-msg.js';

const CONFIG_SCRIPT_ID = 'auth-otp-payment-modal-config';
const NS = '.authOtpPaymentModal';
const PIN_CLASS = '.pin_class';

function readConfig() {
    const el = document.getElementById(CONFIG_SCRIPT_ID);
    if (!el) {
        throw new Error('initAuthOtpPaymentModal: #' + CONFIG_SCRIPT_ID + ' script tag is required');
    }
    return JSON.parse(el.textContent || '{}');
}

function getAuthOtpModal() {
    return $('#payAuthModal');
}

function closeAuthOtpPayModal() {
    getAuthOtpModal().modal('hide');
}

function resendPin(config) {
    const $modal = getAuthOtpModal();
    $.ajax({
        url: config.routes.resendOtp,
        type: 'POST',
        data: {
            congregation_name: config.congregationName,
            cc_id: $modal.find('#cc_id').val(),
            payment_type: 'saved',
            process_type: 'token',
            user_id: config.userId,
            donation_amount: config.sessionDonation.donationAmount,
            donation_type: config.sessionDonation.donationType,
            campaign_id: config.sessionDonation.campaignId,
            charity_amount: config.sessionDonation.charityAmount,
            charity_id: config.sessionDonation.charityId,
            cover_surcharge: config.sessionDonation.coverSurcharge,
            checkout_intent: checkoutIntentFor($modal),
            _token: config.csrfToken,
        },
        success: function (response) {
            if (!response.success) {
                $modal.find('#ModalErrMsg').show();
                $modal.find('#pin_err').html(response.error);
            } else {
                $modal.find('#ModalResendMsg').show();
                $modal.find('#resend_msg').html('The pin was texted to you.  Please enter that pin above.');
            }
        },
        error: function () {
            showAlertMsg('A time out error occurred, please try again', 'danger');
            openIndexPage();
        },
    });
}

function submitOtp(config) {
    localStorage.clear();
    const $modal = getAuthOtpModal();
    $.ajax({
        url: config.routes.confirmOtpPayment,
        type: 'POST',
        data: {
            otp: $modal.find('#otp').val(),
            cc_id: $modal.find('#cc_id').val(),
            donation_type: config.sessionDonation.donationType,
            donation_amount: config.sessionDonation.donationAmount,
            campaign_id: config.sessionDonation.campaignId,
            charity_amount: config.sessionDonation.charityAmount,
            charity_id: config.sessionDonation.charityId,
            frequency_id: config.sessionDonation.frequencyId,
            cover_surcharge: config.sessionDonation.coverSurcharge,
            duration: config.sessionDonation.duration,
            process_type: 'token',
            payment_type: 'saved',
            user_id: config.userId,
            checkout_intent: checkoutIntentFor($modal),
            _token: config.csrfToken,
        },
        success: function (data) {
            if (chargeWentThrough(data)) {
                if (data.success) {
                    try {
                        clearCheckoutIntent($modal);
                    } catch (err) {
                        console.error('auth-otp-payment-modal: clearCheckoutIntent failed', err);
                    }
                }
                try {
                    $modal.modal('hide');
                    cleanupBootstrapModalBody();
                } catch (err) {
                    console.error('auth-otp-payment-modal: close modal after charge failed', err);
                }
                try {
                    if (data.error && !data.payment_processed) {
                        showAlertMsg(data.error, 'danger');
                    }
                } catch (err) {
                    console.error('auth-otp-payment-modal: post-charge alert failed', err);
                }
                applyChargeSuccess(data);
                return;
            }
            hideOverlay(getMemberOverlayElement());
            $modal.find('#ModalErrMsg').show();
            $modal.find('#pin_err').html(data.error);
        },
        error: function () {
            hideOverlay(getMemberOverlayElement());
            $modal.modal('hide');
            cleanupBootstrapModalBody();
            showAlertMsg(AJAX_TIMEOUT_MESSAGE, 'danger');
            openIndexPage();
        },
    });
}

function isDigitKeypress(e) {
    return isAllowedPinKey(e.key, e.target.value);
}

export function initAuthOtpPaymentModal() {
    const config = readConfig();

    $(document).off(NS).on('click' + NS, '[data-action="close-auth-otp-pay-modal"]', function (e) {
        e.preventDefault();
        closeAuthOtpPayModal();
    });

    $(document).on('click' + NS, '[data-action="resend-otp-pin"]', function (e) {
        e.preventDefault();
        resendPin(config);
    });

    $(document).on('submit' + NS, '#payAuth', function (e) {
        e.preventDefault();
        const $modal = $(this).closest('.modal');
        $modal.find('#ModalErrMsg').hide();
        $modal.find('#ModalResendMsg').hide();
        showOverlay(getMemberOverlayElement());
        submitOtp(config);
    });

    $(document).off('keypress' + NS, PIN_CLASS).on('keypress' + NS, PIN_CLASS, function (e) {
        if (!isDigitKeypress(e)) {
            e.preventDefault();
        }
    });
}
